import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getInlineLoader, getCookie } from "../Helpers";
import { MdAddPhotoAlternate, MdClose, MdInfo } from "react-icons/md";
import {
  STR_ADD_SHORT_MESSAGE_AND_PIC,
  STR_AT_LEAST_ONE_IMAGE,
  STR_CREATE_POST,
  STR_IMAGES,
  STR_ITEM_DESCRIPTION,
  STR_POST_ITEM,
  STR_SHARE_SOMETHING,
  STR_SUBMIT,
  STR_SUCCESS
} from "../Strings";

export default function View(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  const [description, setDescription] = useState("");
  const [img1, setImg1] = useState(null);
  const [img2, setImg2] = useState(null);
  const [img3, setImg3] = useState(null);

  const [preview1, setPreview1] = useState("");
  const [preview2, setPreview2] = useState("");
  const [preview3, setPreview3] = useState("");

  async function init() {
    setReady(false);
    //..
    setReady(true);
  }

  function createPreview(file, slot) {
    if (!file) {
      if (slot === 1) setPreview1("");
      if (slot === 2) setPreview2("");
      if (slot === 3) setPreview3("");
      return;
    }

    const url = URL.createObjectURL(file);

    if (slot === 1) setPreview1(url);
    if (slot === 2) setPreview2(url);
    if (slot === 3) setPreview3(url);
  }

  function clearImage(slot) {
    if (slot === 1) {
      setImg1(null);
      setPreview1("");
      const el = document.getElementById('_img1');
      if (el) el.value = "";
    }
    if (slot === 2) {
      setImg2(null);
      setPreview2("");
      const el = document.getElementById('_img2');
      if (el) el.value = "";
    }
    if (slot === 3) {
      setImg3(null);
      setPreview3("");
      const el = document.getElementById('_img3');
      if (el) el.value = "";
    }
  }

  async function submit() {
    const _img1 = document.getElementById('_img1')?.files?.[0];
    const _img2 = document.getElementById('_img2')?.files?.[0];
    const _img3 = document.getElementById('_img3')?.files?.[0];

    // backend required: userId + description + at least one image (photo1/2/3)
    const userId = getCookie("userId");

    if (!userId) {
      appContext.tellError("Session expired, please login again");
      return;
    }

    if (description && description.trim().length > 0) {
      if (_img1 || _img2 || _img3) {

        setLoading(true);
        await callApi(
          "create-post",
          {
            description,
            photo1: (_img1 || ''),
            photo2: (_img2 || ''),
            photo3: (_img3 || ''),
          }
        ).then((response) => {
          if (response.status === 1) {
            appContext.tellMessage(STR_SUCCESS[appContext.language]);
            appContext.getPostsFeed();
            appContext.navBack();
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_AT_LEAST_ONE_IMAGE[appContext.language]);
      }
    } else {
      appContext.tellError("Please add a description");
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [loading])

  useEffect(() => {
    // cleanup previews on unmount
    return () => {
      if (preview1) URL.revokeObjectURL(preview1);
      if (preview2) URL.revokeObjectURL(preview2);
      if (preview3) URL.revokeObjectURL(preview3);
    }
  }, [preview1, preview2, preview3])

  function renderImageTile(params) {
    const { slot, preview, label } = params;

    return (
      <div className="col-4" style={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <div
          className="mShadow2"
          style={{
            width: "100%",
            borderRadius: "18px",
            background: "rgba(255,255,255,0.55)",
            border: "1px solid rgba(0,0,0,0.06)",
            overflow: "hidden",
            position: "relative",
            aspectRatio: "1 / 1",
          }}
        >
          {
            (preview) ?
              <>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url(${preview})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                  }}
                />

                <div
                  onClick={() => clearImage(slot)}
                  className="mShadow2"
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    width: "26px",
                    height: "26px",
                    borderRadius: "13px",
                    background: "rgba(0,0,0,0.55)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <MdClose size={18} color="#fff" />
                </div>
              </>
              :
              <label
                htmlFor={`_img${slot}`}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                <MdAddPhotoAlternate size={26} className="text-primary" />
                <div
                  className="font-semi-bold"
                  style={{
                    fontSize: "12px",
                    marginTop: "6px",
                    opacity: 0.8,
                  }}
                >
                  {label}
                </div>
              </label>
          }
        </div>

        <input
          id={`_img${slot}`}
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          className="form-control"
          style={{
            position: "absolute",
            left: "-9999px",
            width: "1px",
            height: "1px",
            opacity: 0,
          }}
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (slot === 1) setImg1(f || null);
            if (slot === 2) setImg2(f || null);
            if (slot === 3) setImg3(f || null);
            createPreview(f || null, slot);
          }}
        />
      </div>
    )
  }

  if (ready) {
    return (
      <div className="container" style={{ paddingBottom: "40px" }}>
        <div className="row">

          {/* Title */}
          <div className="col-md-12">
            <h6 className="main-section-title" style={{ marginBottom: "18px" }}>
              {STR_CREATE_POST[appContext.language]}
            </h6>
          </div>

          {/* Modern card shell */}
          <div className="col-md-12">
            <div
              className="mShadow3"
              style={{
                borderRadius: "26px",
                background: "rgba(244,244,244,0.80)",
                backdropFilter: "blur(14px)",
                WebkitBackdropFilter: "blur(14px)",
                border: "1px solid rgba(0,0,0,0.06)",
                overflow: "hidden",
              }}
            >
              {/* Header accent */}
              <div style={{ padding: "18px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "4px",
                    borderRadius: "10px",
                    background: "linear-gradient(90deg, var(--primaryColor), var(--secondaryColor))",
                    marginBottom: "14px",
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    marginBottom: "6px",
                  }}
                >
                  <div
                    className="mShadow1"
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "14px",
                      background: "rgba(255,255,255,0.6)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid rgba(0,0,0,0.06)",
                    }}
                  >
                    <MdInfo className="text-primary" size={20} />
                  </div>

                  <div>
                    <h6 className="mNoMargin font-semi-bold" style={{ fontSize: "16px" }}>
                      {STR_SHARE_SOMETHING[appContext.language]}
                    </h6>
                    <p className="mNoMargin font-regular" style={{ fontSize: "12px", opacity: 0.7 }}>
                      {STR_ADD_SHORT_MESSAGE_AND_PIC[appContext.language]}
                    </p>
                  </div>
                </div>
              </div>

              {/* Body */}
              <div style={{ padding: "18px", paddingTop: "0px" }}>
                <div className="row">

                  {/* Description */}
                  <div className="col-md-12 mt-2 mb-2">
                    <label className="form-label">{STR_ITEM_DESCRIPTION[appContext.language]}</label>
                    <textarea
                      className="form-control"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      maxLength={1000}
                      style={{
                        borderRadius: "18px",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                        minHeight: "120px",
                      }}
                    />
                    <div className="form-text" style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ opacity: 0.6 }}>{String(description || "").length}/1000</span>
                    </div>
                  </div>

                  {/* Images */}
                  <div className="col-md-12 mt-2 mb-2">
                    <label className="form-label">{STR_IMAGES[appContext.language]}</label>
                    <div className="form-text">{STR_AT_LEAST_ONE_IMAGE[appContext.language]}</div>

                    <div className="row" style={{ marginTop: "10px" }}>
                      {renderImageTile({ slot: 1, preview: preview1, label: "Photo 1" })}
                      {renderImageTile({ slot: 2, preview: preview2, label: "Photo 2" })}
                      {renderImageTile({ slot: 3, preview: preview3, label: "Photo 3" })}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-md-12 mt-3 mb-2">
                    <button
                      className="btn btn-padded btn-block btn-primary btn-rounded"
                      onClick={submit}
                    >
                      {STR_SUBMIT[appContext.language]}
                    </button>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }

}
